<template>
  <div
    class="bg-accent-dark d-flex justify-center align-center flex-column px-12"
    style="height: 60vh;"
  >
    <h1
      v-html="title"
      class="text-center my-4 display-2 font-weight-bold customFont"
    ></h1>
    <h2 v-html="text" class="text-center my-4"></h2>
    <v-icon size="34" class="black--text">mdi-chevron-down</v-icon>
  </div>
</template>
<style scoped>
.bg-accent-dark {
  background-color: #f9a61b !important;
}
h1 {
  font-family: "Eras Medium ITC" !important;
}
.customFont {
  font-family: "Eras Medium ITC" !important;
}
</style>
<script>
export default {
  props: ["text", "title"],
  data() {
    return {};
  },
};
</script>
